// video tutorial https://www.youtube.com/watch?v=WpIDez53SK4

import { auth } from "./firebase";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    sendEmailVerification,
    updatePassword,
    signInWithPopup,
    GoogleAuthProvider,
    signInWithRedirect,
    GithubAuthProvider,
    deleteUser
} from "firebase/auth";

export const doCreateUserWithEmailAndPassword = async (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
};

// Firebase Google Authentication - Account Picker https://groups.google.com/g/firebase-talk/c/gxBm0WKCuIY
// Firebase logout not working as supposed to https://groups.google.com/g/firebase-talk/c/wpntS7RLha8
export const doSignInWithGoogle = async () => {
    var provider = new GoogleAuthProvider();
    provider.addScope('email'); // fix dash as identifier in Firebase console https://stackoverflow.com/a/59831908
    provider.setCustomParameters({
        prompt: 'select_account'
    });
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // add user to firestore
};

// https://www.freecodecamp.org/news/github-user-authentication-using-firebase-and-reactjs-with-hooks/
export const doSignInWithGitHub = async () => {
    var provider = new GithubAuthProvider();
    provider.setCustomParameters({
        prompt: 'select_account'
    });
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // add user to firestore
};

export const doSignOut = () => {
    return auth.signOut();
};

export const doPasswordReset = (email) => {
    return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
    return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
    return sendEmailVerification(auth.currentUser, {
        url: `${window.location.origin}/home`,
    });
};

export const doDeleteUser = () => {
    return deleteUser(auth.currentUser)
};